import redirect from 'cerebral-module-router/redirect'
import { set } from 'cerebral/operators'
import setFetchOptions from '../../app/actions/setFetchOptions'
import setSearchOptions from '../../app/actions/setSearchOptions'
import setRegistrationStepError from '../actions/setRegistrationStepError'
import isShouldGetUnapprovedUsers from '../actions/isShouldGetUnapprovedUsers.js'
import sendSignInInfo from '../actions/sendSignInInfo'
import setUser from '../actions/setUser'
import getUnapprovedUsers from '../../app/actions/getUnapprovedUsers'
import setUnapprovedUsers from '../../app/actions/setUnapprovedUsers'
import setAdminClientHelperForLoggedInUser from '../../user/actions/setAdminClientHelperForLoggedInUser'
import setAdminClientHelperForCurrentUser from '../../user/actions/setAdminClientHelperForCurrentUser'
import validateForm from 'cerebral-module-forms/factories/validateForm'
import shouldRedirectToExternalModule from '../actions/shouldRedirectToExternalModule'
import redirectToModule from '../actions/redirectToModule'
import setAgreeDBPRTerms from 'modules/app/actions/setAgreeDBPRTerms'
import setUserLocale from '../actions/setUserLocale'
import loadTranslations from 'modules/app/actions/loadTranslations'

export default [
  sendSignInInfo,
  {
    error: [
      validateForm('client.registrating.current.login'),
      setRegistrationStepError
    ],
    success: [
      shouldRedirectToExternalModule,
      {
        true: [redirectToModule],
        false: [
          set('state:app.showAlreadyAgreedGDPRTerms', false),
          setUser,
          setUserLocale,
          loadTranslations,
          {
            true: [],
            false: []
          },
          setAgreeDBPRTerms,
          setAdminClientHelperForLoggedInUser,
          setAdminClientHelperForCurrentUser,
          setFetchOptions,
          setSearchOptions,
          isShouldGetUnapprovedUsers,
          {
            true: [
              getUnapprovedUsers,
              {
                success: [setUnapprovedUsers]
              }
            ],
            false: []
          },
          redirect('/welcome')
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/login/chains/onSignIn.js